import { ProjectEntity } from "@/shared/lib/db";
import { projectLocalRepository } from "../repositories/project.local.repository";
import { ProjectRepository } from "../repositories/project.repository";

class ProjectService {
  constructor(private repo: ProjectRepository) {}

  async get(id: string): Promise<ProjectEntity | null> {
    return this.repo.get(id) as Promise<ProjectEntity | null>
  }

  async getAll(): Promise<ProjectEntity[]> {    
    return this.repo.getAll()
  }

  async save(project: ProjectEntity): Promise<void> {
    return this.repo.save(project)
  }

  async delete(id: string): Promise<void> {
    return this.repo.delete(id)
  }
}

export const projectService = new ProjectService(projectLocalRepository)